<template>
    <div>
        <self-back :pageHeaderList="[{'name':'投放平台配置'}]"></self-back>
        <div class="content" v-loading='loading'>
                <button class="addaccountButton" @click="addaccountEvent">+ 添加平台</button>
            <el-table
                class="table"
                :header-cell-style="{background:'#f5f7fa'}"
                :data="accountList"
                :max-height="tableMaxHeight"
                border
                >
                <el-table-column
                prop="platform_name"
                label="平台名称"
                align='center'
                >
                </el-table-column>
                <el-table-column
                align='center'
                label="默认"
                >
                    <template slot-scope="scope">
                        <i class="el-icon-circle-check" v-if="scope.row.is_default==1" style="color: #5c7bfe;font-size: 16px;"></i>
                    </template>
                </el-table-column>
                <el-table-column
                align='center'
                label="操作">
                    <template slot-scope="scope">
                        <button @click="modifyaccountEvent(scope.row)">修改</button>
                        <button v-if="scope.row.del_enable==1" style="background:#FC726D" @click="deleteaccountFlagEvent(scope.row)">删除</button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="paginationBox">
                <el-pagination
                    small
                    background
                    :current-page="page"
                    @current-change="handleCurrentChange"
                    :page-size="page_size"
                    layout="total, prev, pager, next"
                    :total="total">
                </el-pagination>
            </div>
        </div>
        <!-- 添加账号 -->
        <el-dialog
            :title="isEdit?'修改平台':'添加平台'"
            :visible.sync="addaccountFlag"
            width="30%"
            :close-on-click-modal='false'
            center>
            <div class="dialogBox">
                <div class="dialogitem">
                    <label><em>*</em>平台名称：</label>
                    <el-input
                        :disabled="isEdit?true:false"
                        placeholder="请输入平台名称"
                        style="width:67%"
                        v-model.trim="accountName"
                        size='small'
                        clearable>
                    </el-input>
                </div>
                <div class="dialogitem">
                    <label>设为默认：</label>
                    <el-checkbox v-model="isDefault">是</el-checkbox>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelAddaccount" size="mini">取 消</el-button>
                <el-button type="primary" @click="addaccountYes" size="mini">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data(){
        return{
            addaccountFlag:false,
            deleteaccountFlag:false,
            accountList:[],
            accountName:'',
            page:1,
            page_size:20,
            total:0,
            loading:false,
            isEdit:false,
            vebateId:'',
            isDefault:false
        }
    },
    computed: {
        // 计算表格最大高度，确保分页控件可见
        tableMaxHeight() {
            // Header(60) + self-back(50) + padding(30) + button(30) + table-margin(15) + pagination(40) + pagination-margin(15) + footer(70) + footer-margin(10) = 320px
            return window.innerHeight - 120;
        }
    },
    created(){
        this.accountsListEvent(1)
    },
    methods:{
        addaccountEvent(){//点击添加账号按钮
            this.addaccountFlag = true;
            this.isEdit = false;
        },
        deleteaccountFlagEvent(data){//删除账号
            this.$confirm('确定要删除该配置?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.$axios.post(this.URL.BASEURL + this.URL.platformDel,{
                        id: data.id,
                    }).then((res) => {
                        var res=res.data;
                        if(res&& res.errno == 0){
                            this.accountsListEvent(this.page)
                        }else {
                            this.$message({
                                message: res.err,
                                type: 'warning'
                            })
                        }
                    }).catch(()=>{
                    })
                }).catch(() => {        
            });
        },
        handleCurrentChange(val){
            this.accountsListEvent(val)
        },
        accountsListEvent(page){
           this.loading = true;
           this.page = page
           this.$axios.get(this.URL.BASEURL + this.URL.platformList,{
               params:{
                   page: page,
                   page_size: this.page_size,
               }
            }).then((res) => {
                var res=res.data;
                this.loading = false;
                if(res&& res.errno == 0){
                    this.accountList = res.rst.data;
                    this.total = res.rst.pageInfo.total;
                }else {
                    this.$message({
                        message: res.err,
                        type: 'warning'
                    })
                }
            }).catch(()=>{
                this.loading = false
            })
        },
        addaccountYes(){//添加账号
            if(this.accountName == ''){
                this.$message({
                    message: '请输入平台名称',
                    type: 'fail'
                })
                return
            }
            if(this.isEdit){//编辑
                this.$axios.post(this.URL.BASEURL + this.URL.platformEdit,{
                    id: this.vebateId,
                    platform_name: this.accountName,
                    is_default: this.isDefault?1:0
                }).then((res) => {
                    var res=res.data;
                    if(res&& res.errno == 0){
                        this.accountsListEvent(this.page)
                        this.cancelAddaccount()
                    }else {
                        this.$message({
                            message: res.err,
                            type: 'warning'
                        })
                    }
                }).catch(()=>{
                })
            }else{
                this.$axios.post(this.URL.BASEURL + this.URL.platformAdd,{
                    platform_name: this.accountName,
                    is_default: this.isDefault?1:0
                }).then((res) => {
                    var res=res.data;
                    if(res&& res.errno == 0){
                        this.accountsListEvent(this.page)
                        this.cancelAddaccount()
                    }else {
                        this.$message({
                            message: res.err,
                            type: 'warning'
                        })
                    }
                }).catch(()=>{
                })
            }
        },
        cancelAddaccount(){//取消添加账号
            this.addaccountFlag = false;
            this.accountName = '';
            this.isDefault = false;
        },
        modifyaccountEvent(data){//修改账号
            this.accountName = data.platform_name;
            this.vebateId = data.id;
            this.isDefault = data.is_default == 1 ? true : false;
            this.isEdit = true;
            this.addaccountFlag = true;
        }
    },
    watch:{
       
    }
}
</script>
<style lang="scss" scoped>
.content{
    width: 100%;
    background: #FFFFFF;
    box-shadow: 0px 2px 6px 0px rgba(32, 38, 82, 0.1);
    padding: 15px 15px 15px;
    flex-direction: column;
    box-sizing: border-box;
    min-height: calc(100vh - 140px);
    .addaccountButton{
        height: 30px;
        background: #5B7BFE;
        border-radius: 4px;
        color: #FFFFFF;
        font-size: 13px;
        border:none;
        padding:0 10px;
        flex-shrink: 0;
    }
    .table{
        margin-top: 15px;
        flex: 1;
        min-height: 0;
        button{
            min-width: 48px;
            height: 22px;
            background: #5B7BFE;
            border-radius: 4px;
            color: #FFFFFF;
            font-size: 12px;
            border: none;
            padding: 0 6px;
        }
    }
    .paginationBox{
        flex-shrink: 0;
        margin-top: 15px;
        padding-bottom: 0;
    }
}
.dialogitem{
    margin-bottom: 20px;
    &:last-of-type{
        margin-bottom: 0;
    }
    label{
        display: inline-block;
        width: 100px;
        color: #202652;
        font-size: 14px;
        line-height: 20px;
        em{
            color: red;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/disposeAdmin/platformConfigure.vue